import React, { Component } from "react";
import {
  Modal,
  Select,
  DatePicker,
  alert,
  format_date,
  copyText,
  float,
  GET,
  POST,
  PUT,
  UPLOAD,
  t,
} from "../CustomComponent.js";
import { COIN_ICON, coin, coinFromBaht } from "../wallet_option.js";
import { fileSize } from "../partner_option.js";
import {
  AMOUNT_PRESETS,
  CANCELABLE_STATUSES,
  SLIP_MAX_SIZE,
  SLIP_ACCEPT,
  SLIP_FOLDER,
  FALLBACK_COIN,
  statusMeta,
  partnerStatusLabel,
  channelMeta,
  channelsFrom,
  accountFor,
  bankLabel,
  bankLogo,
  PROMPTPAY_LOGO,
  baht,
} from "../topup_option.js";

/* ============================================================================
 * กล่อง "เติมเหรียญ" ของพาร์ตเนอร์
 *
 * เปิดจากปุ่มข้างยอดเหรียญบนหัวหน้าหลังบ้าน (NavbarAdmin) — วางไว้ตรงนั้นเพราะ
 * คนที่คิดจะเติมคือคนที่เพิ่งมองยอดตัวเองแล้วเห็นว่าใกล้หมด ปุ่มจึงควรอยู่ติดกับยอด
 * ไม่ใช่ซ่อนอยู่ในเมนูอีกชั้น และเข้าถึงได้จากทุกหน้าโดยไม่ต้องทิ้งงานที่ทำค้างไว้
 *
 * สองแท็บอยู่ในกล่องเดียวกันโดยตั้งใจ :
 *   ส่งคำขอ     ฟอร์มโอนเงิน + แนบสลิป
 *   คำขอของฉัน  สถานะของที่ส่งไปแล้ว
 * ถ้ามีแต่ฟอร์ม พาร์ตเนอร์จะไม่รู้ว่าใบที่ส่งไปเมื่อวานถึงไหนแล้ว แล้วส่งซ้ำอีกใบ
 * ทีมการเงินก็ต้องมานั่งไล่ว่าใบไหนซ้ำกับใบไหน
 *
 * props.readonly = เปิดจากฝั่งแอดมิน : เห็นฟอร์มเดียวกันเป๊ะ ๆ ด้วยอัตราและบัญชี
 * รับเงินของจริง แต่กรอกและส่งไม่ได้ — คำขอเติมต้องผูกกับกระเป๋าของผู้ขอ ซึ่งมีแต่
 * พาร์ตเนอร์เท่านั้นที่มี เปิดไว้ให้ทีมที่ดูแลระบบเหรียญตรวจได้ว่าค่าที่ตั้งในหน้า
 * "ตั้งค่าเหรียญ" ออกมาหน้าตาแบบไหนในมือพาร์ตเนอร์ โดยไม่ต้องไปขอยืมบัญชีใครเปิดดู
 *
 * ต่อกับ API แล้ว :
 *   GET  admin/wallet-topups/me           คำขอของตัวเอง (แท็บ "คำขอที่ส่งแล้ว")
 *   POST admin/wallet-topups              ส่งคำขอ (สลิปอัปขึ้น R2 ก่อนแล้วส่ง URL มา)
 *   PUT  admin/wallet-topups/:uid/cancel  ยกเลิกใบที่ยังไม่มีใครตัดสิน
 *
 * เส้นทางทั้งสามไม่มี checkPermission ที่ route โดยตั้งใจ — บทบาท "พาร์ตเนอร์"
 * ไม่ได้ถือสิทธิ์ wallet-topups.* (นั่นเป็นสิทธิ์ของคนที่ตรวจคำขอของคนอื่น)
 * ตัวจำกัดอยู่ที่ service ซึ่งยึด user_id จาก token เสมอ
 * ========================================================================== */

const isTh = () => (localStorage.getItem("lang") || "TH") !== "EN";
const locale = () => (isTh() ? "th" : "en");

const dateText = (value) => (value ? format_date(value, "dd mmm yyyy", locale()) : "-");
const dateTimeText = (value) => (value ? format_date(value, "dd mmm yyyy hh:mm", locale()) : "-");

const EMPTY_FORM = {
  amount: "",
  // ว่างไว้ = ใช้ช่องทางแรกที่ตั้งบัญชีไว้ (ดู currentChannel) ไม่ล็อกค่าตายตัว
  // เพราะบริษัทอาจตั้งไว้เฉพาะพร้อมเพย์ก็ได้
  channel: "",
  transferred_date: null,
  transferred_time: "",
  note: "",
};

export default class TopupModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tab: "form",
      form: { ...EMPTY_FORM },
      // คำขอของตัวเอง — โหลดตอนกล่องถูกเปิด (ดู componentDidUpdate)
      requests: [],
      loaded: false,
      sending: false,
      // สลิปที่กดขยายดู (ทับอยู่ในกล่องเดิม ไม่เปิดกล่องซ้อนกล่อง)
      zoom: false,

      /* ข้อมูลสลิปที่เลือกไว้ (ชื่อ/ขนาด/รูปพรีวิว) — ตัวไฟล์จริงอยู่ที่ this.slipFile
         เพราะ File object ไม่ได้ใช้ตอน render และไม่ควรอยู่ใน state */
      slip: null,
    };

    this.slipFile = null;
  }

  componentDidUpdate(prev) {
    /* โหลดตอน "เปิด" ไม่ใช่ตอน mount — กล่องนี้ถูกวาดค้างไว้ที่ NavbarAdmin ทุกหน้า
       ยิงตั้งแต่ mount เท่ากับยิงคำขอเพิ่มหนึ่งครั้งในทุกหน้าที่ผู้ใช้เปิด ทั้งที่
       ส่วนใหญ่ไม่เคยกดเปิดกล่องเลย

       ฝั่งแอดมิน (readonly) ไม่มีคำขอของตัวเอง จึงไม่ต้องยิง — และยิงไปก็ได้ 403
       กลับมาเพราะ /me เปิดให้เฉพาะบัญชีพาร์ตเนอร์ */
    if (!prev.show && this.props.show && !this.props.readonly) this.GetRequests();
  }

  componentWillUnmount() {
    this.clearSlip();
  }

  /* คำขอของพาร์ตเนอร์ที่ล็อกอินอยู่ — ยึด user_id จาก token ฝั่ง backend
     ไม่ต้องส่ง uid ของตัวเองไป (และส่งไปก็ไม่มีผล)

     พังก็ปล่อยเงียบ ๆ : กล่องนี้เปิดมาเพื่อ "ส่งคำขอ" เป็นหลัก แท็บประวัติเป็นของ
     ประกอบ เด้ง error ใส่หน้าผู้ใช้ตั้งแต่เปิดกล่องจะขวางงานที่เขาตั้งใจมาทำ */
  GetRequests = async () => {
    const result = await GET("admin/wallet-topups/me", { page: 1, page_size: 20 });
    this.setState({ requests: result?.status ? result.data || [] : [], loaded: true });
  };

  /* คืนหน่วยความจำของ object URL ที่สร้างไว้พรีวิว */
  clearSlip = () => {
    if (this.state.slip?.preview) URL.revokeObjectURL(this.state.slip.preview);
    this.slipFile = null;
  };

  setForm = (patch) => this.setState((prev) => ({ form: { ...prev.form, ...patch } }));

  /* ค่าตั้งค่าเหรียญที่ตั้งไว้ในหน้า "ตั้งค่า › ตั้งค่าเหรียญ" — มาพร้อมยอดเหรียญจาก
     GET admin/wallets/overview (ดู wallet.service.getOverview) ไม่ใช่ค่าคงที่ในหน้านี้
     FALLBACK_COIN กันหน้าจอพังตอนยิงไม่ผ่าน ไม่ใช่ค่าที่ตั้งใจให้ใช้จริง */
  config = () => ({ ...FALLBACK_COIN, ...(this.props.coin || {}) });

  /* ช่องทางที่กำลังเลือกอยู่ — ยังไม่ได้เลือกเองให้ใช้ช่องทางแรกที่มีบัญชีปลายทาง */
  currentChannel = () => {
    const channels = channelsFrom(this.config());
    return this.state.form.channel || channels[0]?.value || "";
  };

  /* ชื่อหน่วยเหรียญตามที่ตั้งไว้ ("เหรียญ" / "แต้ม" / ชื่อแบรนด์) */
  coinUnit = () => String(this.config().coin_name || "").trim() || t("wallet_unit_coin");

  /* ------------------------------------------------------------ เลือกสลิป */
  PickSlip = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    if (file.size > SLIP_MAX_SIZE) return alert("", "warning", t("warning"), t("topup_verify_slip_size"));

    this.clearSlip();
    this.slipFile = file;

    this.setState({
      slip: {
        name: file.name,
        size: file.size,
        // PDF ไม่ต้องทำพรีวิว — แสดงเป็นการ์ดชื่อไฟล์แทน
        preview: file.type.startsWith("image/") ? URL.createObjectURL(file) : "",
      },
    });
  };

  RemoveSlip = () => {
    this.clearSlip();
    this.setState({ slip: null });
  };

  /* ------------------------------------------------------------- ส่งคำขอ */
  Save = async () => {
    /* กันไว้อีกชั้นถึงแม้ปุ่มส่งจะถูกถอดออกไปแล้วตอน readonly — เผื่อวันหลังมีคนต่อ
       ปุ่มอื่นเข้ามาเรียกเมธอดนี้ กติกา "ส่งได้เฉพาะพาร์ตเนอร์" จะได้ไม่หลุดไปด้วย
       (ด่านจริงอยู่ที่ backend เสมอ ที่นี่เป็นแค่ UX) */
    if (this.props.readonly) return;

    const { form } = this.state;
    const coin_config = this.config();
    const amount = Number(form.amount) || 0;
    const channel = this.currentChannel();

    if (!channel) return alert("", "warning", t("warning"), t("topup_no_account"));
    if (amount <= 0) return alert("", "warning", t("warning"), t("topup_verify_amount"));
    if (coin_config.min_topup > 0 && amount < coin_config.min_topup)
      return alert("", "warning", t("warning"), `${t("topup_verify_min")} ${baht(coin_config.min_topup)} ${t("baht")}`);
    if (coin_config.max_topup > 0 && amount > coin_config.max_topup)
      return alert("", "warning", t("warning"), `${t("topup_verify_max")} ${baht(coin_config.max_topup)} ${t("baht")}`);
    if (!form.transferred_date) return alert("", "warning", t("warning"), t("topup_verify_date"));
    if (!this.slipFile) return alert("", "warning", t("warning"), t("topup_verify_slip"));

    if (!(await alert("", "info", t("confirm"), t("topup_confirm_submit"), t("confirm"), t("cancel")))) return;

    this.setState({ sending: true });

    /* 1) อัปสลิปขึ้น R2 ก่อน — ไฟล์วิ่งตรงเข้าบักเก็ตผ่าน presigned URL ไม่ผ่าน body
       ของ API (เหมือนเอกสารใบสมัครพาร์ตเนอร์) ได้ URL กลับมาแล้วค่อยส่งคำขอ

       ลำดับนี้กลับกันไม่ได้ : ถ้าสร้างคำขอก่อนแล้วค่อยอัปสลิป พอสลิปอัปไม่ผ่าน
       จะเหลือใบที่ไม่มีหลักฐานค้างอยู่ในคิวให้ทีมการเงินงง ทางนี้ถ้าอัปไม่ผ่าน
       ก็แค่ไม่มีใบเกิดขึ้น ผู้ใช้กดส่งใหม่ได้ทันที (ไฟล์กำพร้าบน R2 ไม่กระทบใคร) */
    const uploaded = await UPLOAD(this.slipFile, { folder: SLIP_FOLDER });
    if (!uploaded?.status) {
      this.setState({ sending: false });
      /* ใช้ไอคอน warning ชุดเดียวกับที่ services/api ใช้แจ้ง error ของ API —
         ผู้ใช้จะได้ไม่เจอกล่องหน้าตาคนละแบบสำหรับความล้มเหลวคนละขั้นของงานเดียวกัน */
      return alert("", "warning", t("warning"), uploaded?.message || t("topup_slip_upload_fail"));
    }

    /* 2) ส่งคำขอ — ยอดเหรียญที่จะได้ backend เป็นคนคำนวณและตรึงอัตราไว้ที่ใบเอง
       ไม่ได้ส่งขึ้นไปจากที่นี่ (ค่าที่ผู้ขอส่งมาเองไม่ใช่ค่าที่ควรเชื่อ) */
    const result = await POST("admin/wallet-topups", {
      amount,
      channel,
      transferred_at: this.transferredAt(),
      slip_path: uploaded.data.file_path,
      slip_name: uploaded.data.file_name,
      slip_mime: uploaded.data.mime_type,
      slip_size: uploaded.data.file_size,
      ...(form.note.trim() ? { note: form.note.trim() } : {}),
    });

    this.setState({ sending: false });
    if (!result?.status) return;

    this.clearSlip();
    this.setState({ slip: null, form: { ...EMPTY_FORM }, tab: "history" });

    // โหลดรายการใหม่จาก backend แทนการเดาแถวเอง — เลขที่คำขอ backend เป็นคนออกให้
    await this.GetRequests();

    // ยอดเหรียญบนหัวหน้ายังไม่ขยับ (เหรียญเข้าตอนอนุมัติ) จึงไม่ต้องบอกให้ Navbar โหลดใหม่
    await alert("", "success", t("success"), `${result.data?.code || ""}\n${t("topup_submitted")}`, t("confirm"));
  };

  /* วันที่ + เวลาที่โอน รวมเป็นเวลาเดียว — ช่องเวลาเป็นตัวเลือก ไม่กรอกก็ใช้ต้นวัน
     ทีมการเงินไล่หาในรายการเงินเข้าด้วยวันเป็นหลัก เวลาช่วยแคบให้แถวที่ยอดซ้ำกัน */
  transferredAt = () => {
    const { transferred_date, transferred_time } = this.state.form;
    if (!transferred_date) return null;

    const at = new Date(transferred_date);
    const [hour, minute] = String(transferred_time || "").split(":");
    at.setHours(Number(hour) || 0, Number(minute) || 0, 0, 0);

    return at.toISOString();
  };

  /* ยกเลิกคำขอของตัวเอง — ทำได้เฉพาะใบที่ยังไม่มีใครรับเรื่อง */
  Cancel = async (item) => {
    if (this.props.readonly) return;
    if (!(await alert("", "warning", t("topup_action_cancel"), t("topup_cancel_confirm"), t("confirm"), t("cancel"))))
      return;

    const result = await PUT(`admin/wallet-topups/${item.uid}/cancel`, null);
    if (!result?.status) return;

    // โหลดใหม่แทนการแก้แถวในมือ — ใบนี้อาจถูกทีมการเงินตัดสินไปแล้วระหว่างที่กล่องเปิดค้าง
    await this.GetRequests();
  };

  /* ======================================================= ตัวช่วย render */
  /* กล่องบัญชีปลายทาง — ต้องคัดลอกเลขบัญชีได้ ไม่ใช่ให้จดตามหน้าจอ
     copyText มีข้อความแจ้งของตัวเองอยู่แล้ว จึงไม่เรียก alert ซ้อนทับ */
  renderAccount = () => {
    const coin_config = this.config();
    const account = accountFor(coin_config, this.currentChannel());

    /* ยังไม่ได้ตั้งบัญชีรับเงินในหน้าตั้งค่าเหรียญ — บอกตรง ๆ ว่าเติมไม่ได้ตอนนี้
       ดีกว่าปล่อยให้กรอกจนจบแล้วไม่รู้จะโอนไปไหน */
    if (!account) {
      return (
        <div className="ppl-note ppl-note--warn">
          <span className="icon">{"\uf06a"}</span>
          <div>{t("topup_no_account")}</div>
        </div>
      );
    }

    const isBank = account.channel === "bank_transfer";

    return (
      <div className="tpu-acct">
        <div className="tpu-acct__head">
          <span className="icon">{"\uf19c"}</span>
          {t("topup_transfer_to")}
        </div>

        {/* โลโก้ + ชื่อธนาคาร — คนหาบัญชีปลายทางในแอปธนาคารจากโลโก้ก่อนอ่านชื่อ */}
        <div className="tpu-acct__row">
          <span className="tpu-acct__label">{isBank ? t("topup_bank") : t("topup_channel")}</span>
          <span className="tpu-acct__bank">
            <img className="tpu-acct__logo" src={isBank ? bankLogo(account.bank) : PROMPTPAY_LOGO} alt="" />
            <b>{isBank ? bankLabel(account.bank, isTh()) : t("topup_channel_promptpay")}</b>
          </span>
        </div>

        <div className="tpu-acct__row">
          <span className="tpu-acct__label">{isBank ? t("topup_account_no") : t("coin_promptpay")}</span>
          {/* คัดลอกได้ ไม่ใช่ให้จดตามหน้าจอ — copyText มีข้อความแจ้งของตัวเองแล้ว
              จึงไม่เรียก alert ซ้อนทับ */}
          <button type="button" className="tpu-acct__copy" onClick={() => copyText(account.account_no)}>
            <b>{account.account_no}</b>
            <span className="icon text-12">{"\uf0c5"}</span>
          </button>
        </div>

        {!!account.account_name && (
          <div className="tpu-acct__row">
            <span className="tpu-acct__label">{t("topup_account_name")}</span>
            <b>{account.account_name}</b>
          </div>
        )}

        {!!coin_config.payment?.note && <div className="tpu-acct__note">{coin_config.payment.note}</div>}
      </div>
    );
  };

  renderSlipPicker = () => {
    const { slip } = this.state;

    if (!slip) {
      return (
        <label className="tpu-drop">
          <input type="file" accept={SLIP_ACCEPT} onChange={this.PickSlip} />
          <span className="tpu-drop__icon icon">{"\uf0ee"}</span>
          <span className="tpu-drop__title">{t("topup_slip_pick")}</span>
          <span className="tpu-drop__hint">{t("topup_slip_hint")}</span>
        </label>
      );
    }

    return (
      <div className="tpu-slip">
        {slip.preview ? (
          <button type="button" className="tpu-slip__thumb" onClick={() => this.setState({ zoom: true })}>
            <img src={slip.preview} alt="" />
            <span className="tpu-slip__zoom icon">{"\uf065"}</span>
          </button>
        ) : (
          <span className="tpu-slip__thumb tpu-slip__thumb--file icon">{"\uf1c1"}</span>
        )}

        <div className="min-w-0 flex-grow-1">
          <div className="tpu-slip__name text-truncate">{slip.name}</div>
          <div className="tpu-slip__size">{fileSize(slip.size)}</div>
        </div>

        <button type="button" className="tpu-slip__remove icon" title={t("delete_action")} onClick={this.RemoveSlip}>
          {"\uf00d"}
        </button>
      </div>
    );
  };

  /* หัวของแต่ละขั้น — เลขวงกลม + ชื่อขั้น + คำอธิบายสั้น ๆ
     ตัวเลขไม่ได้มีไว้ให้ดูสวย : ฟอร์มนี้ผู้ใช้ต้องสลับไปทำงานนอกจอจริง ๆ (เปิดแอป
     ธนาคารไปโอน) แล้วกลับมาต่อ การมีลำดับให้จับทำให้กลับมาแล้วรู้ทันทีว่าค้างอยู่ตรงไหน */
  step = (number, title, desc, body) => (
    <section className="tpu-step">
      <header className="tpu-step__head">
        <span className="tpu-step__num">{number}</span>
        <div className="min-w-0">
          <div className="tpu-step__title">{t(title)}</div>
          <div className="tpu-step__desc">{t(desc)}</div>
        </div>
      </header>
      <div className="tpu-step__body">{body}</div>
    </section>
  );

  /* ==================================================== render : ฟอร์ม */
  /* แบ่งเป็นสามขั้นตามลำดับที่คนทำจริง : ตกลงจำนวน -> ไปโอน -> กลับมาแจ้งหลักฐาน
     ของเดิมเป็นแผงยาวแผงเดียว ทุกช่องน้ำหนักเท่ากันหมด คนเปิดมาครั้งแรกไม่รู้ว่า
     ต้องเริ่มตรงไหนและช่องไหนต้องกรอกหลังจากออกไปโอนเงินแล้ว
     ช่องกรอกยังเป็นชุดเดิมทุกช่อง เปลี่ยนแค่การจัดวาง */
  renderForm = () => {
    const { form } = this.state;
    const coin_config = this.config();
    const unit = this.coinUnit();
    const channels = channelsFrom(coin_config);
    const amount = Number(form.amount) || 0;
    const willGet = coinFromBaht(amount, coin_config.coin_per_baht);

    return (
      <div className="tpu-form">
        {this.step(
          1,
          "topup_step_amount",
          "topup_step_amount_desc",
          <>
            <div>
              <label className="prop-label">{t("topup_amount")}</label>
              <div className="tpu-affix">
                <input
                  type="text"
                  inputMode="decimal"
                  className="prop-field"
                  placeholder="0"
                  value={form.amount}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (value !== "" && !float(value, 2)) return;
                    this.setForm({ amount: value });
                  }}
                />
                <span className="tpu-affix__unit">{t("baht")}</span>
              </div>
              <div className="d-flex flex-wrap gap-2 mt-2">
                {AMOUNT_PRESETS.map((preset) => (
                  <button
                    key={preset}
                    type="button"
                    aria-pressed={amount === preset}
                    className={`tpu-preset${amount === preset ? " is-on" : ""}`}
                    onClick={() => this.setForm({ amount: String(preset) })}
                  >
                    {baht(preset)}
                  </button>
                ))}
              </div>
            </div>

            {/* ผลลัพธ์เป็นแถบเต็มความกว้างใต้ช่องกรอก ไม่ใช่การ์ดข้าง ๆ : คนกรอกคิดเป็น
                "บาท" แต่สิ่งที่ได้คือเหรียญ สองอย่างนี้จึงต้องอ่านต่อกันเป็นประโยคเดียว
                จากบนลงล่าง ไม่ใช่กวาดตาไปมาซ้ายขวา และวางแบบนี้จอแคบก็ไม่ต้องหักคอลัมน์ */}
            <div className="tpu-result">
              <span className="tpu-result__coin icon">{COIN_ICON}</span>
              <div className="min-w-0 flex-grow-1">
                <div className="tpu-result__label">{t("topup_will_get")}</div>
                <div className="tpu-result__value">
                  {coin(willGet)}
                  <span className="tpu-result__unit">{unit}</span>
                </div>
              </div>
              <div className="tpu-result__rate">
                <div>
                  1 {t("baht")} = {coin(coin_config.coin_per_baht)} {unit}
                </div>
                {coin_config.min_topup > 0 && (
                  <div>
                    {t("topup_min_short")} {baht(coin_config.min_topup)}
                  </div>
                )}
              </div>
            </div>
          </>
        )}

        {this.step(
          2,
          "topup_step_transfer",
          "topup_step_transfer_desc",
          <>
            {/* มีช่องทางเดียวก็ไม่ต้องให้เลือก — กล่องบัญชีด้านล่างบอกอยู่แล้วว่าโอนยังไง */}
            {channels.length > 1 && (
              <div>
                <label className="prop-label">{t("topup_channel")}</label>
                <Select
                  className="prop-field prop-select"
                  default={false}
                  placeholder={t("select")}
                  value={this.currentChannel()}
                  options={channels.map((item) => ({ value: item.value, label: t(item.label) }))}
                  onChange={(value) => value && this.setForm({ channel: value })}
                />
              </div>
            )}

            {this.renderAccount()}
          </>
        )}

        {this.step(
          3,
          "topup_step_confirm",
          "topup_step_confirm_desc",
          <>
            {/* วันที่กับเวลาแบ่งครึ่งพอดี — ของเดิมเป็น 3+3 ในแถว 12 ช่อง แล้วเหลือที่ว่าง
                ครึ่งแถวลอยอยู่ทุกครั้งที่ช่องทางมีอันเดียว (ซึ่งเป็นกรณีปกติ) */}
            <div className="tpu-grid">
              <div>
                <label className="prop-label">{t("topup_transferred_date")}</label>
                <DatePicker
                  type={isTh() ? "th" : "en"}
                  className="prop-field"
                  value={form.transferred_date}
                  onChange={(value) => this.setForm({ transferred_date: value ? new Date(value) : null })}
                />
              </div>

              <div>
                <label className="prop-label">
                  {t("topup_transferred_time")} <span className="fw-normal text-secondary">({t("optional")})</span>
                </label>
                <input
                  type="time"
                  className="prop-field"
                  value={form.transferred_time}
                  onChange={(e) => this.setForm({ transferred_time: e.target.value })}
                />
              </div>
            </div>

            <div>
              <label className="prop-label">{t("topup_slip")}</label>
              {this.renderSlipPicker()}
            </div>

            <div>
              <label className="prop-label">
                {t("note")} <span className="fw-normal text-secondary">({t("optional")})</span>
              </label>
              <textarea
                className="prop-field"
                rows={2}
                maxLength={500}
                placeholder={t("topup_note_placeholder")}
                value={form.note}
                onChange={(e) => this.setForm({ note: e.target.value })}
              />
            </div>
          </>
        )}

        <div className="ppl-note">
          <span className="icon">{"\uf05a"}</span>
          <div>{t("topup_pending_hint")}</div>
        </div>
      </div>
    );
  };

  renderFormFoot = () => (
    <div className="tpu-foot">
      <button type="button" className="prop-btn prop-btn--ghost" onClick={this.props.onHide}>
        {t("cancel")}
      </button>
      {/* ยังไม่ได้ตั้งบัญชีรับเงิน = ไม่มีปลายทางให้โอน ส่งคำขอไปก็ไม่มีประโยชน์ */}
      <button
        type="button"
        className="prop-btn"
        disabled={this.state.sending || !this.currentChannel()}
        onClick={this.Save}
      >
        <span className="icon text-12">{"\uf1d8"}</span>
        {t("topup_submit")}
      </button>
    </div>
  );

  /* ท้ายกล่องฝั่งแอดมิน — มีปุ่มปิดอย่างเดียว
     ไม่มีปุ่มส่ง (ส่งไม่ได้) และไม่แถมทางลัดไปหน้าอื่นด้วย : กล่องนี้เปิดมาเพื่อ "ดู"
     ปุ่มที่พาออกจากสิ่งที่กำลังดูอยู่คือของแถมที่ทำให้ท้ายกล่องดูเหมือนมีอะไรให้ทำ
     ทั้งที่ไม่มี — เมนูรายการเติมเหรียญอยู่ที่แถบข้างตามเดิมอยู่แล้ว */
  renderPreviewFoot = () => (
    <div className="tpu-foot">
      <button type="button" className="prop-btn prop-btn--ghost" onClick={this.props.onHide}>
        {t("close")}
      </button>
    </div>
  );

  /* ท้ายกล่องของแท็บ "คำขอที่ส่งแล้ว" — ไม่มีอะไรให้ส่ง แต่ต้องมีแถบนี้อยู่
     นี่คือต้นเหตุจริงที่กล่องยังเด้งตอนสลับแท็บ แม้จะล็อกความสูงของเนื้อในไปแล้ว :
     เดิมแถบท้ายวาดเฉพาะแท็บฟอร์ม พอสลับมาแท็บนี้แถบหายไปทั้งแถบ ตัวกล่องจึงเตี้ยลง
     ตามความสูงของแถบที่หายไป */
  renderHistoryFoot = () => (
    <div className="tpu-foot">
      <button type="button" className="prop-btn prop-btn--ghost" onClick={this.props.onHide}>
        {t("close")}
      </button>
    </div>
  );

  /* =============================================== render : คำขอที่ส่งแล้ว */
  /* แถวคำขอหนึ่งใบ — สูงสองบรรทัด (สามเมื่อมีเหตุผลที่ไม่อนุมัติ)
     ของเดิมเป็นการ์ดสูง ๆ ที่วางทุกอย่างเรียงลงมาเป็นบรรทัดของตัวเอง : เลขที่ สถานะ
     ยอดเงิน ช่องทาง วันโอน วันส่ง ห้าหกบรรทัดต่อหนึ่งใบ พอมีหลายใบก็ต้องเลื่อนยาว
     ทั้งที่คนเปิดแท็บนี้มาถามอยู่คำถามเดียวคือ "ใบที่ส่งไปถึงไหนแล้ว"

     จัดใหม่ตามลำดับที่ตาไล่ : สถานะซ้ายสุด (คำตอบของคำถามนั้น) -> ยอดเงินตรงกลาง
     (ตัวที่ใช้แยกใบออกจากกันเวลาส่งหลายใบ) -> รายละเอียดที่เหลือย่อเป็นบรรทัดเดียว
     เลขที่คำขอลงไปอยู่บรรทัดล่างเพราะไม่มีใครจำเลขที่ได้ ใช้ตอนอ้างอิงกับทีมงานเท่านั้น */
  renderHistoryRow = (item) => {
    const meta = statusMeta(item.status);
    const cancelable = CANCELABLE_STATUSES.includes(item.status);

    return (
      <div className="tpu-item" key={item.uid}>
        {/* จุดสีสถานะ — บอกผลได้ตั้งแต่ยังไม่ทันอ่านตัวหนังสือ และทำให้แถวที่ยัง
            รอตรวจสอบเด้งออกมาจากใบที่จบไปแล้วเวลากวาดตาลงมาทั้งรายการ
            สีมาจาก statusMeta ชุดเดียวกับคิวตรวจฝั่งผู้ดูแล ทั้งสองฝั่งจะได้ไม่เล่า
            เรื่องเดียวกันด้วยสีคนละชุด (ต่างกันแค่ "คำ" ดู partnerStatusLabel) */}
        <span className="tpu-item__mark icon" style={{ background: meta.tint, color: meta.tone }}>
          {meta.icon}
        </span>

        <div className="tpu-item__main">
          <div className="tpu-item__money">
            <b>{baht(item.amount)}</b> {t("baht")}
            <span className="tpu-item__arrow icon">{"\uf061"}</span>
            <b>{coin(item.coin)}</b> {this.coinUnit()}
          </div>

          {/* ทุกอย่างที่เหลือรวมเป็นบรรทัดเดียว คั่นด้วยจุด — แต่ละชิ้นสั้นเกินกว่าจะ
              คุ้มกับการกินบรรทัดของตัวเอง วันเวลาที่ส่งไปอยู่ใน tooltip */}
          <div className="tpu-item__meta" title={`${t("topup_submitted_at")} ${dateTimeText(item.created_at)}`}>
            <span className="tpu-item__code">{item.code}</span>
            <span className="tpu-item__sep">·</span>
            {t(channelMeta(item.channel).label)}
            <span className="tpu-item__sep">·</span>
            {t("topup_transferred_at")} {dateText(item.transferred_at)}
          </div>
        </div>

        {/* ฝั่งขวาเป็นคอลัมน์สองบรรทัดชิดขวา ตรงกับสองบรรทัดของฝั่งซ้ายพอดี :
            บรรทัดบนคือ "ตอนนี้เป็นยังไง" บรรทัดล่างคือ "ทำอะไรกับมันได้"
            ของเดิมเอาปุ่มยกเลิกไปวางเป็นคอลัมน์ที่สามลอยกลางแถว กลายเป็นสามก้อน
            แย่งพื้นที่กันในแถวเตี้ย ๆ และแถวที่ยกเลิกไม่ได้ก็เหลือช่องว่างค้างไว้

            คำสถานะฝั่งพาร์ตเนอร์ต่างจากฝั่งผู้ดูแล — เขาอ่านในฐานะผลของเรื่องที่
            ตัวเองขอ (สำเร็จ/ไม่สำเร็จ) ไม่ใช่ผลของงานที่คนอื่นทำ (อนุมัติ/ไม่อนุมัติ) */}
        <div className="tpu-item__side">
          <span className="tpu-item__status" style={{ color: meta.tone }}>
            {t(partnerStatusLabel(item.status))}
          </span>

          {cancelable && (
            <button type="button" className="tpu-item__cancel" onClick={() => this.Cancel(item)}>
              <span className="icon">{"\uf00d"}</span>
              {t("topup_action_cancel")}
            </button>
          )}
        </div>

        {/* เหตุผลที่ไม่อนุมัติต้องอ่านได้จากที่นี่ ไม่ต้องโทรถาม — วางเป็นบรรทัดที่สาม
            เต็มความกว้างใต้ทั้งแถว ไม่ใช่ยัดในคอลัมน์ซ้ายจนบรรทัดสั้นกุด */}
        {!!item.reason && (
          <div className="tpu-item__reason">
            <span className="icon text-12">{"\uf06a"}</span>
            {item.reason}
          </div>
        )}
      </div>
    );
  };

  renderHistory = () => {
    const { requests, loaded } = this.state;

    if (!requests.length) {
      /* แยก "ยังโหลดไม่เสร็จ" ออกจาก "ไม่มีคำขอ" — ขึ้นว่ายังไม่เคยส่งคำขอทั้งที่
         ข้อมูลกำลังเดินทางอยู่ คือการบอกสิ่งที่ยังไม่รู้ว่าจริงไหม และคนที่เพิ่งกดส่งไป
         เมื่อกี้จะตกใจว่าใบหายไปไหน */
      return (
        <div className="tpu-empty">
          <span className="icon">{loaded ? "\uf15c" : "\uf110"}</span>
          {loaded ? t("topup_no_request") : t("loading")}
        </div>
      );
    }

    return <div className="tpu-list">{requests.map(this.renderHistoryRow)}</div>;
  };

  render() {
    const { show, onHide, balance, readonly } = this.props;
    const { tab, zoom } = this.state;
    if (!show) return null;

    const pending = this.state.requests.filter((item) => item.status === "pending").length;

    return (
      <Modal size="lg" show={show} onHide={onHide} centered contentClassName="tpu-modal">
        {/* หัวกล่อง : ยอดปัจจุบันอยู่ตรงนี้เพื่อให้ตัดสินใจได้ว่าจะเติมเท่าไร */}
        <div className="tpu-hero">
          <span className="tpu-hero__coin icon">{COIN_ICON}</span>
          <div className="min-w-0 flex-grow-1">
            <div className="tpu-hero__title">{t("topup_title")}</div>
            {/* ฝั่งแอดมินไม่มีกระเป๋าของตัวเอง โชว์ "เหรียญของฉัน 0" ตรงนี้จะเป็นการโกหก
                จึงเปลี่ยนเป็นบอกไปตรง ๆ ว่ากำลังดูมุมมองของพาร์ตเนอร์อยู่ */}
            <div className="tpu-hero__balance">
              {readonly ? (
                t("topup_preview_badge")
              ) : (
                <>
                  {t("wallet_my_coin")} <b>{coin(balance)}</b> {this.coinUnit()}
                </>
              )}
            </div>
          </div>
          {/* ปุ่มปิดมาจาก Modal ของโปรเจกต์เอง (มุมบนขวา) ไม่ต้องวาดซ้ำ */}
        </div>

        {/* "คำขอของฉัน" ไม่มีความหมายกับแอดมิน (ไม่มีคำขอของตัวเอง) และคำขอของ
            คนอื่นอยู่ที่หน้ารายการเติมเหรียญซึ่งมีตัวกรองกับหลักฐานครบกว่า
            เหลือแท็บเดียวก็ไม่ต้องมีแถบแท็บ */}
        {!readonly && (
          <div className="tpu-tabs">
            <button
              type="button"
              className={`tpu-tab${tab === "form" ? " is-on" : ""}`}
              onClick={() => this.setState({ tab: "form" })}
            >
              <span className="icon text-12">{"\uf067"}</span>
              {t("topup_tab_form")}
            </button>
            <button
              type="button"
              className={`tpu-tab${tab === "history" ? " is-on" : ""}`}
              onClick={() => this.setState({ tab: "history" })}
            >
              <span className="icon text-12">{"\uf1da"}</span>
              {t("topup_tab_history")}
              {!!pending && <span className="tpu-tab__count">{pending}</span>}
            </button>
          </div>
        )}

        {/* มีแท็บเมื่อไหร่ กล่องต้องสูงคงที่ — ดู .tpu-body--tabs ใน wallet.css
            ฝั่งแอดมินไม่มีแท็บให้สลับ กล่องจึงหดตามเนื้อในได้ตามปกติ */}
        <Modal.Body className={`tpu-body${readonly ? "" : " tpu-body--tabs"}`}>
          {readonly ? (
            <>
              {/* บอกตั้งแต่บรรทัดแรกว่ากรอกไม่ได้ ไม่ใช่ปล่อยให้กดช่องแรกแล้วงงว่าทำไมพิมพ์ไม่ออก */}
              <div className="ppl-note mb-3">
                <span className="icon">{"\uf06e"}</span>
                <div>{t("topup_readonly_note")}</div>
              </div>

              {/* fieldset ปิดทั้งชุดด้วยกลไกของเบราว์เซอร์เอง — ไม่ต้องไล่ใส่ disabled
                  ทีละช่อง และไม่มีทางลืมช่องใดช่องหนึ่งตอนเพิ่มฟิลด์ใหม่ทีหลัง
                  minWidth: 0 ทับค่าเริ่มต้น min-inline-size: min-content ของ fieldset
                  ที่จะดันเนื้อในจนล้นกล่องเมื่อจอแคบ */}
              <fieldset disabled className="border-0 p-0 m-0" style={{ minWidth: 0 }}>
                {this.renderForm()}
              </fieldset>
            </>
          ) : tab === "form" ? (
            this.renderForm()
          ) : (
            this.renderHistory()
          )}

          {/* สลิปที่กดขยาย — ทับอยู่ในกล่องเดิม (z-index ต่ำกว่ากล่องแจ้งเตือนของ swal) */}
          {zoom && !!this.state.slip?.preview && (
            <button type="button" className="tpu-zoom" onClick={() => this.setState({ zoom: false })}>
              <img src={this.state.slip.preview} alt="" />
            </button>
          )}
        </Modal.Body>

        {readonly ? this.renderPreviewFoot() : tab === "form" ? this.renderFormFoot() : this.renderHistoryFoot()}
      </Modal>
    );
  }
}
